module.exports = __webpack_public_path__ + "static/frontUserNew/img/door-nav-install-apply.b056bbef.png";